<template>
    <div class="main">
        <div class='footer' @click='videoplay'>
            <p class='loadingtext' v-if='!pointshow'>加载中</p>
            <img src="http://wwj.jijiagames.com/web/act/20190312/point.png" class='point' alt="" v-if='pointshow'>
        </div>
        <video
            src="http://wwj.jijiagames.com/web/act/20190312/lingluo.mp4"
            preload="true"
            x-webkit-airplay="true"
            playsinline="true"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            ref="videoPlayer"
            class="video-player"
            @canplay="videoCanPlay"
            @ended="ended"
            @paused="ended"
            v-show="videoPlayerShow"
            >
        </video>
    </div>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {
            videoPlayerShow: false,
            pointshow: false,
            progress: 0
        };
    },
    methods: {
        videoCanPlay() {
            clearInterval(this.timer);
            setTimeout(() => {
                this.timer = setInterval(() => {
                    this.progress += 1;
                    if (this.progress >= 100) {
                        this.progress = 100;
                        clearInterval(this.timer);
                        this.pointshow = true;
                    }
                }, 10);
            }, 800);
        },
        ended() {
            this.$emit('nextpage');
            this.$refs.videoPlayer.pause();
            this.videoPlayerShow = false;
        },
        videoplay() {
            if (this.pointshow) {
                this.videoPlayerShow = true;
                this.$refs.videoPlayer.play();
            }
        }
    },
    mounted() {
        this.timer = setInterval(() => {
            this.progress += 1;
            if (this.progress >= Math.floor((Math.random() * 20) + 50)) {
                clearInterval(this.timer);
                setTimeout(() => {
                    this.videoCanPlay();
                }, 2000);
            }
        }, 15);
    },
    created() {
    }
};
</script>

<style lang="stylus" scoped>
@keyframes scaleDraw {
    0% {
        transform scale(1)
    }
    25% {
        transform scale(1.2)
    }
    50% {
        transform scale(1)
    }
    75% {
        transform scale(1.2)
    }
}
.main
    size 100%
    overflow hidden
    position relative
    background url('http://wwj.jijiagames.com/web/act/20190312/index.jpg') 0 0/100% 100% no-repeat
    .footer
        width 100%
        height 4.5rem
        position absolute
        bottom 0
        display flex
        background url('/img/lingluo/loading.gif') 0 0/100% 100% no-repeat
        flex-direction row
        align-items center
        justify-content center
        .loadingtext
            position absolute
            top 0.8rem
            left 47.5%
            font-size 0.22rem
            color #fff
        .point
            width 0.8rem
            height 1rem
            margin-left 20%
            margin-top -4%
            opacity 0.6
            -webkit-animation scaleDraw 3s ease-in-out infinite
.video-player
    size 100%
    position absolute
    top 0
    background #000
    object-fit fill
    z-index 100
    vertical-align middle
video
    size 100%
    position absolute
    top 0
    left 0
    object-fit cover
</style>
